package org.example.zone360.pages.authentication

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import org.example.zone360.utils.changePassword
import com.stevdza.san.kotlinbs.components.showToast
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.left
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.top
import com.varabyte.kobweb.compose.ui.modifiers.transform
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.silk.components.icons.fa.FaXmark
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import kotlinx.browser.document
import kotlinx.coroutines.launch
import org.example.zone360.components.CommonButton
import org.example.zone360.components.InputField
import org.example.zone360.componentss.FieldTitleText
import org.example.zone360.componentss.FieldTitleTextNormal
import org.example.zone360.componentss.FieldTitleTextNormalSimple
import org.example.zone360.theme.Palette
import org.example.zone360.theme.toSitePalette
import org.example.zone360.utils.AppGlobal
import org.example.zone360.utils.Res
import org.example.zone360.utils.ToastID
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.w3c.dom.HTMLInputElement


@Composable
fun ChangePasswordPage(
    onDialogDismiss: () -> Unit,
    toastMessage: (String) -> Unit,
) {
    val scope = rememberCoroutineScope()
    val sitePalette = ColorMode.current.toSitePalette()

    var showCurrent by remember { mutableStateOf(false) }
    var showNew by remember { mutableStateOf(false) }
    var showConfirm by remember { mutableStateOf(false) }
    var isErrorCurrent by remember { mutableStateOf(false) }
    var isErrorNew by remember { mutableStateOf(false) }
    var isErrorConfirm by remember { mutableStateOf(false) }
    var newPass by remember { mutableStateOf("") }
    var confirm by remember { mutableStateOf("") }

    var serverMessage by remember { mutableStateOf<String?>(null) }

    var isLoading by remember { mutableStateOf(false) }

    fun performChangePassword() {
        val current =
            (document.getElementById(Res.Id.currentPasswordInput) as HTMLInputElement).value.trim()

        isErrorCurrent = false
        isErrorNew = false
        isErrorConfirm = false
        serverMessage = null

        when {
            current.isBlank() -> {
                isErrorCurrent = true
                return
            }

            newPass.isBlank() || newPass.length < 8 -> {
                isErrorNew = true
                return
            }

            confirm != newPass-> {
                isErrorConfirm = true
                return
            }
        }

        scope.launch {
            isLoading = true
            try {
                val response = changePassword(
                    email = AppGlobal.userData.email,
                    currentPassword = current,
                    newPassword = newPass,
                    confirmPassword = confirm
                )
                if (response.data == "Password updated successfully!") {
                    toastMessage("Password changed successfully")
                    showToast(ToastID.SUCCESS)
                    onDialogDismiss()
                } else {
                    serverMessage = response.error
                }
            } catch (t: Throwable) {
                serverMessage = "Failed to change password: ${t.message}"
            } finally {
                isLoading = false
            }
        }
    }
    Box(
        modifier = Modifier
            .position(Position.Fixed)
            .top(0.px)
            .left(0.px)
            .width(100.percent)
            .height(100.percent)
            .zIndex(999)
            .backgroundColor(Palette.Grey.rgbLight.copyf(alpha = 0.7f)),
        contentAlignment = Alignment.Center
    )
    {
        Box(
            modifier = Modifier
                .width(460.px)
                .position(Position.Fixed)
                .zIndex(9)
                .top(50.percent)
                .left(50.percent)
                .transform { translate((-50).percent, (-50).percent) }
                .borderRadius(6.px)
                .padding(30.px),
            contentAlignment = Alignment.Center
        ) {
            Box(
                Modifier.color(Colors.Black)
                    .backgroundColor(sitePalette.modalBackgroundColor.rgb)
                    .maxWidth(400.px)
                    .border(
                        width = 1.px,
                        color = sitePalette.textFieldBorderColor.rgb,
                        style = LineStyle.Solid
                    )
                    .borderRadius(6.px),
                contentAlignment = Alignment.Center
            ) {
                Column(
                    modifier = Modifier.padding(topBottom = 30.px, leftRight = 30.px),
                ) {
                    Row(
                        modifier = Modifier.fillMaxWidth().padding(bottom = 25.px),
                        horizontalArrangement = Arrangement.SpaceBetween,
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        FieldTitleText(text = "Change Password", marginBottom = 0.px)
                        FaXmark(
                            modifier = Modifier
                                .color(sitePalette.commonButtonSupportiveTextColor.rgb)
                                .cursor(Cursor.Pointer)
                                .onClick { onDialogDismiss() },
                            size = IconSize.LG
                        )
                    }
                    Row(
                        Modifier.fillMaxWidth(),
                        horizontalArrangement = Arrangement.SpaceBetween,
                    ) {
                        FieldTitleTextNormal(text = "Current Password") {}
                        FieldTitleTextNormalSimple(
                            text = if (showCurrent) "Hide" else "Show",
                            onClick = { showCurrent = !showCurrent },
                            isClickable = true,
                            color = sitePalette.primary.rgb
                        )
                    }
                    InputField(
                        errorText = "Please enter your current password",
                        inputType = if (showCurrent) InputType.Text else InputType.Password,
                        placeHolder = "",
                        id = Res.Id.currentPasswordInput,
                        isError = isErrorCurrent,
                        marginBottom = 3.px,
                        onEnterPress = ::performChangePassword
                    )

                    Row(
                        Modifier.fillMaxWidth().margin(top = 25.px),
                        horizontalArrangement = Arrangement.SpaceBetween
                    ) {
                        FieldTitleTextNormal(text = "New Password") {}
                        FieldTitleTextNormalSimple(
                            text = if (showNew) "Hide" else "Show",
                            onClick = { showNew = !showNew },
                            isClickable = true,
                            color = sitePalette.primary.rgb
                        )
                    }
                    Column(modifier = Modifier.fillMaxWidth()) {
                        InputField(
                            onValueChange = {
                                newPass = it
                                isErrorNew = false
                            },
                            inputType = if (showNew) InputType.Text else InputType.Password,
                            placeHolder = "",
                            id = Res.Id.newPasswordInput,
                            marginBottom = 3.px,
                            onEnterPress = ::performChangePassword
                        )
                        if (isErrorNew) {
                            Box(modifier = Modifier.fillMaxWidth()) {
                                FieldTitleTextNormalSimple(
                                    text = "Password must be at least 8 characters",
                                    marginTop = 3.px,
                                    fontSize = 11.px,
                                    color = sitePalette.textErrorColor.rgb,
                                )
                            }
                        }
                    }

                    Row(
                        Modifier.fillMaxWidth().margin(top = 25.px),
                        horizontalArrangement = Arrangement.SpaceBetween
                    ) {
                        FieldTitleTextNormal(text = "Confirm Password") {}
                        FieldTitleTextNormalSimple(
                            text = if (showConfirm) "Hide" else "Show",
                            onClick = { showConfirm = !showConfirm },
                            isClickable = true,
                            color = sitePalette.primary.rgb
                        )
                    }
                    Column(modifier = Modifier.fillMaxWidth()) {
                        InputField(
                            onValueChange = {
                                confirm = it
                                isErrorConfirm = false
                            },
                            inputType = if (showConfirm) InputType.Text else InputType.Password,
                            placeHolder = "",
                            id = Res.Id.confirmPasswordInput,
                            isError = isErrorConfirm,
                            marginBottom = 3.px,
                            onEnterPress = ::performChangePassword
                        )
                        if (isErrorConfirm) {
                            Box(modifier = Modifier.fillMaxWidth()) {
                                FieldTitleTextNormalSimple(
                                    text = "Passwords do not match",
                                    marginTop = 3.px,
                                    fontSize = 11.px,
                                    color = sitePalette.textErrorColor.rgb,
                                )
                            }
                        }
                    }


                    Box(Modifier.margin(topBottom = 10.px)) { }
                    CommonButton(
                        byPassEmailVerification = true,
                        text = "Change Password",
                        isLoading = isLoading,
                        onCLick = ::performChangePassword
                    )
                    serverMessage?.let {
                        FieldTitleTextNormalSimple(
                            width = 100.percent,
                            textAlign = TextAlign.Center,
                            text = it,
                            color = if (it.contains(
                                    "success",
                                    ignoreCase = true
                                )
                            ) sitePalette.primary.rgb else sitePalette.textErrorColor.rgb
                        )
                    }

                }
            }
        }
    }
}


